<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div v-if="permission.access">
    <b-card>
      <validation-observer ref="loginValidation">
        <b-form
          class="auth-login-form mt-2"
          @submit.prevent
          enctype="multipart/form-data"
        >
          <div class="row">
            <!-- $store.state.base_url + 'images/CIT-13-Years.jpg' -->
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-6">
                  <!-- email -->
                  <b-form-group label="Aspire Title" label-for="aspire_title">
                    <validation-provider
                      #default="{ errors }"
                      name="aspire_title"
                      rules="required"
                    >
                      <b-form-input
                        id="aspire_title"
                        v-model="form.aspire_title"
                        :state="errors.length > 0 ? false : null"
                        name="aspire_title"
                        placeholder="Enter Your Aspire Title"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <!-- email -->
                  <b-form-group label="Title" label-for="work_title">
                    <validation-provider
                      #default="{ errors }"
                      name="work_title"
                      rules="required"
                    >
                      <b-form-input
                        id="work_title"
                        v-model="form.work_title"
                        :state="errors.length > 0 ? false : null"
                        name="work_title"
                        placeholder="Enter Your Work Title"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    label="Aspire Description"
                    label-for="aspire_description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="aspire_description"
                      rules="required"
                    >
                      <b-form-textarea
                        id="aspire_description"
                        v-model="form.aspire_description"
                        :state="errors.length > 0 ? false : null"
                        name="aspire_description"
                        placeholder="Enter Your Aspire Description"
                        rows="4"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                    label="Work Description"
                    label-for="work_description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="work_description"
                      rules="required"
                    >
                      <b-form-textarea
                        id="work_description"
                        v-model="form.work_description"
                        :state="errors.length > 0 ? false : null"
                        name="work_description"
                        placeholder="Enter Your Work Description"
                        rows="4"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                    label="Work Life Title"
                    label-for="work_life_title"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="work_life_title"
                      rules="required"
                    >
                      <b-form-input
                        id="work_life_title"
                        v-model="form.work_life_title"
                        :state="errors.length > 0 ? false : null"
                        name="work_life_title"
                        placeholder="Enter Your Work Life Title"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                    label="Facilities Title"
                    label-for="facilities_title"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="facilities_title"
                      rules="required"
                    >
                      <b-form-input
                        id="facilities_title"
                        v-model="form.facilities_title"
                        :state="errors.length > 0 ? false : null"
                        name="facilities_title"
                        placeholder="Enter Your Facilities Title"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                    label="Work Life Description"
                    label-for="work_life_description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="work_life_description"
                      rules="required"
                    >
                      <b-form-textarea
                        id="work_life_description"
                        v-model="form.work_life_description"
                        :state="errors.length > 0 ? false : null"
                        name="work_life_description"
                        placeholder="Work Life Description"
                        rows="4"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                    label="FacilitiesDescription"
                    label-for="facilities_description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="facilities_description"
                      rules="required"
                    >
                      <b-form-textarea
                        id="facilities_description"
                        v-model="form.facilities_description"
                        :state="errors.length > 0 ? false : null"
                        name="facilities_description"
                        placeholder="Enter Your Facilities Description"
                        rows="4"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>

                <div class="col-md-12">
                  <b-form-group label="Meta Title" label-for="meta_title">
                    <validation-provider
                      #default="{ errors }"
                      name="meta_title"
                      rules="required"
                    >
                      <b-form-input
                        id="meta_title"
                        v-model="form.meta_title"
                        :state="errors.length > 0 ? false : null"
                        name="meta_title"
                        placeholder="Enter Your Meta Title"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
                <div class="col-md-12">
                  <b-form-group
                    label="Meta Description"
                    label-for="meta_description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="meta_description"
                      rules="required"
                    >
                      <b-form-textarea
                        id="meta_description"
                        v-model="form.meta_description"
                        :state="errors.length > 0 ? false : null"
                        name="meta_description"
                        placeholder="Enter Your Meta Description"
                        rows="4"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="border rounded p-2 mb-2">
                <h4 class="mb-1">Video Setting</h4>

                <b-media
                  no-body
                  vertical-align="center"
                  class="flex-column flex-md-row"
                >
                  <b-media-aside>
                    <b-img
                      :src="work_image"
                      height="174"
                      width="310"
                      class="rounded mr-2 mb-1 mb-md-0"
                    />
                  </b-media-aside>
                  <b-media-body>
                    <b-form-group
                      label="Video Thumbnail"
                      label-for="work_image"
                    >
                      <b-form-file
                        id="work_image"
                        accept=".jpg, .png, .gif"
                        @change="loadImage($event)"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                      />
                    </b-form-group>
                    <!-- email -->
                    <b-form-group label="Video ID" label-for="work_video_id">
                      <validation-provider
                        #default="{ errors }"
                        name="work_video_id"
                        rules="required"
                      >
                        <b-form-input
                          id="video_id"
                          v-model="form.work_video_id"
                          :state="errors.length > 0 ? false : null"
                          name="work_video_id"
                          placeholder="Enter Your Video ID"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-media-body>
                </b-media>
              </div>
            </div>
          </div>
          <!-- submit buttons -->
          <div class="d-flex justify-content-between">
            <b-form-checkbox
              name="status"
              style="margin-top: 5px"
              v-model="form.status"
              switch
              inline
            >
              Status
            </b-form-checkbox>
            <b-button
              type="submit"
              variant="primary"
              @click="validationForm"
              v-if="permission.edit"
            >
              Update
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BMediaBody,
  BMediaAside,
  BMedia,
  BFormFile,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BFormTextarea,
} from "bootstrap-vue";
import { required, email } from "@core/utils/validations/validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
export default {
  props: ["marketplaces"],
  data() {
    return {
      form: {
        aspire_title: "",
        aspire_description: "",
        work_title: "",
        work_description: "",
        work_video_id: "",
        work_image: "",
        work_life_title: "",
        work_life_description: "",
        facilities_title: "",
        facilities_description: "",
        meta_title: "",
        meta_description: "",
        status: true,
      },

      work_image: null,
      required,
      email,
      permission: {
        access: false,
        create: false,
        edit: false,
        delete: false,
      },
    };
  },
  mounted() {
    this.getResult();
    this.Permission();
  },
  methods: {
    async getResult() {
      const careerOpportunities = await this.callApi(
        "get",
        "/app/career-opportunities-page"
      );
      if (careerOpportunities.status == 200) {
        this.form.aspire_title =
          careerOpportunities.data.careerOpportunities.aspire_title;
        this.form.aspire_description =
          careerOpportunities.data.careerOpportunities.aspire_description;
        this.form.work_title =
          careerOpportunities.data.careerOpportunities.work_title;
        this.form.work_description =
          careerOpportunities.data.careerOpportunities.work_description;
        this.form.work_life_title =
          careerOpportunities.data.careerOpportunities.work_life_title;
        this.form.work_life_description =
          careerOpportunities.data.careerOpportunities.work_life_description;
        this.form.facilities_title =
          careerOpportunities.data.careerOpportunities.facilities_title;
        this.form.facilities_description =
          careerOpportunities.data.careerOpportunities.facilities_description;
        this.form.meta_title =
          careerOpportunities.data.careerOpportunities.meta_title;
        this.form.meta_description =
          careerOpportunities.data.careerOpportunities.meta_description;
        this.form.status =
          careerOpportunities.data.careerOpportunities.status == 1
            ? true
            : false;

        this.form.work_video_id =
          careerOpportunities.data.careerOpportunities.work_video_id;

        this.work_image =
          this.$store.state.base_url +
          (careerOpportunities.data.careerOpportunities.work_image
            ? careerOpportunities.data.careerOpportunities.work_image
            : "images/freelancing/default.jpg");
      }
    },

    loadImage(e) {
      this.form.work_image = e.target.files[0];
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (e) => {
        this.work_image = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    Update() {
      const fd = new FormData();
      if (this.form.work_image) {
        fd.append(
          "work_image",
          this.form.work_image,
          this.form.work_image.name
        );
      }
      fd.append("aspire_title", this.form.aspire_title);
      fd.append("aspire_description", this.form.aspire_description);
      fd.append("work_title", this.form.work_title);
      fd.append("work_description", this.form.work_description);
      fd.append("work_video_id", this.form.work_video_id);
      fd.append("work_life_title", this.form.work_life_title);
      fd.append("work_life_description", this.form.work_life_description);
      fd.append("facilities_title", this.form.facilities_title);
      fd.append("facilities_description", this.form.facilities_description);
      fd.append("meta_title", this.form.meta_title);
      fd.append("meta_description", this.form.meta_description);
      fd.append("status", this.form.status);

      axios
        .post("/app/career-opportunities-page", fd)
        .then((res) => {
          this.getResult();
          this.s(res.data.message);
        })
        .catch((e) => {
          this.e(e.response.data.message);
          if (e.response.status === 422) {
            if (e.response.data.errors.aspire_title)
              this.e(e.response.data.errors.aspire_title[0]);
            if (e.response.data.errors.aspire_description)
              this.e(e.response.data.errors.aspire_description[0]);
            if (e.response.data.errors.work_title)
              this.e(e.response.data.errors.work_title[0]);
            if (e.response.data.errors.work_description)
              this.e(e.response.data.errors.work_description[0]);
            if (e.response.data.errors.work_video_id)
              this.e(e.response.data.errors.work_video_id[0]);
            if (e.response.data.errors.work_life_title)
              this.e(e.response.data.errors.work_life_title[0]);
            if (e.response.data.errors.work_life_description)
              this.e(e.response.data.errors.work_life_description[0]);
            if (e.response.data.errors.facilities_title)
              this.e(e.response.data.errors.facilities_title[0]);
            if (e.response.data.errors.facilities_description)
              this.e(e.response.data.errors.facilities_description[0]);
            if (e.response.data.errors.meta_title)
              this.e(e.response.data.errors.meta_title[0]);
            if (e.response.data.errors.meta_description)
              this.e(e.response.data.errors.meta_description[0]);
            if (e.response.data.errors.status)
              this.e(e.response.data.errors.status[0]);
            if (e.response.data.errors.work_image)
              this.e(e.response.data.errors.work_image[0]);
          }
        });
    },
    async Permission() {
      const permissions = await this.callApi("post", "/app/permission");
      permissions.data.permissions.forEach((permission) => {
        if (permission.slug == "career.opportunities.access") {
          this.permission.access = true;
        }

        if (permission.slug == "career.opportunities.edit") {
          this.permission.edit = true;
        }
      });
    },
    validationForm() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.Update();
        }
      });
    },
  },

  components: {
    vSelect,
    BMedia,
    BFormFile,
    BFormTextarea,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BMediaAside,
    BMediaBody,
    BCard,
  },
};
</script>

<style></style>
